import { render } from "./App.vue?vue&type=template&id=4f75d42b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4f75d42b&lang=scss"
script.render = render

export default script